<div class="p-4 rounded-md shadow dark:shadow-gray-700 sticky top-20">
    <div>
        <h5 class="text-lg font-medium">Price Filter</h5>

        <div class="range-slider mt-3">
            <span class="flex justify-between pb-2">
                <span>
                    <label for="" class="text-lg">$</label>
                    <input type="number" class="text-slate-400 border-0" value={{minrange}} min="0" max="200"/>
                </span>

                <span>
                    <label for="" class="text-lg">$</label>
                    <input type="number" class="text-slate-400 border-0" value={{maxrange}} min="0" max="200"/>
                </span>
            </span>
            <input value="50" min="0" max="200" step="5" type="range" (change)="minValue($event)"/>
            <input value="120" min="0" max="200" step="5" type="range" (change)="maxValue($event)"/>
        </div>
    </div>

    <div class="mt-6">
        <h5 class="text-lg font-medium">Reviews</h5>

        <div class="mt-3">
            <div class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="5star">
                <label class="form-checkbox-label text-slate-400" for="5star">
                    <ul class="font-medium list-none space-x-1">
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                    </ul>
                </label>
            </div>
            <div class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="4star">
                <label class="form-checkbox-label text-slate-400" for="4star">
                    <ul class="font-medium list-none space-x-1">
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                    </ul>
                </label>
            </div>
            <div class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="3star">
                <label class="form-checkbox-label text-slate-400" for="3star">
                    <ul class="font-medium list-none space-x-1">
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                    </ul>
                </label>
            </div>
            <div class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="2star">
                <label class="form-checkbox-label text-slate-400" for="2star">
                    <ul class="font-medium list-none space-x-1">
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                    </ul>
                </label>
            </div>
            <div class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="1star">
                <label class="form-checkbox-label text-slate-400" for="1star">
                    <ul class="font-medium list-none space-x-1">
                        <li class="inline"><i class="mdi mdi-star text-amber-400 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                        <li class="inline"><i class="mdi mdi-star-outline text-slate-200 dark:text-gray-700 align-middle"></i></li>
                    </ul>
                </label>
            </div>
        </div>
    </div>

    <div class="mt-6">
        <h5 class="text-lg font-medium">Booking Activity</h5>

        <div class="mt-3">
            <div *ngFor="let item of booking" class="flex items-center mb-0">
                <input class="form-checkbox rounded border-gray-100 dark:border-gray-800 text-red-500 focus:border-red-300 focus:ring focus:ring-offset-0 focus:ring-red-500/20 focus:ring-opacity-50 me-2" type="checkbox" value="" id="">
                <label class="form-checkbox-label text-slate-400">{{item}}</label>
            </div>
        </div>
    </div>

    <div class="mt-6">
        <h5 class="text-lg font-medium">Tour Map</h5>

        <div class="mt-3">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d39206.002432144705!2d-95.4973981212445!3d29.709510002925988!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c16de81f3ca5%3A0xf43e0b60ae539ac9!2sGerald+D.+Hines+Waterwall+Park!5e0!3m2!1sen!2sin!4v1566305861440!5m2!1sen!2sin" style="border:0" class="w-full h-[300px] rounded-full" allowfullscreen></iframe>
        </div>
    </div>
</div>
